import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "d-flex align-center justify-space-between my-4" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Selecionar Filial", -1)
const _hoisted_6 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_7 = { class: "area-responsibles" }
const _hoisted_8 = ["onClick"]

import { ref, computed, watch, onMounted } from 'vue';
import { Authentication, Preloader } from '@/store';
import { User, Group, Company } from '@/core/model';
import {
  getAll as CompanyAll,
  getHeadquartersByUser,
  getSubsidiariesByHeadquartersId,
} from '@/core/service/CompanyService';
import { MoleculeCompanyModal, MoleculeModal, MoleculeFilterCheckbox } from '@/components/molecules';
import {
  AddUserIcon,
  AtomButton,
  AtomInput,
  SearchIcon,
  AtomCheckBox,
  AtomAccordion,
  AtomSelect,
} from '@/components/atoms';
import { IOptionsSelect } from '@/types';

interface IProps {
  users: User[];
  companys: Company[];
  modelValue: boolean;
  model?: Group;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeGroupModal',
  props: {
    users: null,
    companys: null,
    modelValue: { type: Boolean },
    model: null
  },
  emits: ['handleAddOrUpdate', 'handleAddCompany', 'update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  users: User[];
  companys: Company[];
  modelValue: boolean;
  model?: Group;
};

const optionsMatrizes = ref<IOptionsSelect[]>([]);
const matriz = ref<number>(0);
const disabledButton = computed(() => {
  return !data.value?.subsidiary_id || !data.value?.name;
});

function loadHeadQuarters() {
  getHeadquartersByUser(Number(Authentication.state.value.mkId)).then((f) => {
    optionsMatrizes.value = [{ text: f.data.fantasy_name, value: f.data.id }];
  });
}

function loadSubisidiary() {
  getSubsidiariesByHeadquartersId(matriz.value).then((f) => {
    companys.value = f.data;
  });
}



const data = ref<Group>({});
const showModal = ref<boolean>(false);
const isAdd = ref<boolean>(false);
const search = ref<string>('');

const companys = ref<Company[]>([]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const searchCompanies = computed(() => {
  return search.value
    ? props.companys?.filter((f) => f.fantasy_name?.toUpperCase().includes(search.value.toUpperCase()))
    : props.companys;
});

function setResponsable(item: Company) {
  data.value.subsidiary_id = item.id;
}

function handleAddOrUpdate() {
  emit('handleAddOrUpdate', JSON.parse(JSON.stringify(data.value)));
}

function handleAddCompany(event: boolean) {
  if (event) {
    emit('handleAddCompany', event);
  }
  isAdd.value = false;
}

watch(
  () => props.model,
  () => {
    if (props.model) {
      data.value = props.model;
    }
  }
);

watch(
  () => matriz.value,
  () => {
    loadSubisidiary();
  }
);
watch(
  () => props.modelValue,
  () => {
    if (props.modelValue && !props.model) {
      data.value = {};
    }
  }
);

onMounted(() => {
  loadHeadQuarters();
});

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MoleculeModal), {
      width: "649px",
      onHandleConfirm: handleAddOrUpdate,
      onHandleCancel: _cache[4] || (_cache[4] = ($event: any) => {
      data.value = {};
      value.value = false;
    }),
      title: "Cadastro de Grupo",
      subtitle: 'Preencha todos os campos corretamente para cadastrar um novo grupo',
      show: _unref(value),
      "btn-close-text": "Cancelar",
      "btn-confirm-text": "Salvar",
      btnConfitmDisabled: _unref(disabledButton)
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(AtomInput), {
              maxWidth: '100%',
              msgError: "Campo obrigatório",
              label: "Nome",
              modelValue: data.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.name) = $event)),
              classes: "mb-5",
              hasError: !data.value.name,
              required: ""
            }, null, 8, ["modelValue", "hasError"]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(AddUserIcon)),
                _hoisted_5
              ]),
              (_unref(Authentication).actions.hasPermission('/companies', 'CREATE'))
                ? (_openBlock(), _createBlock(_unref(AtomButton), {
                    key: 0,
                    background: "white",
                    outlined: "",
                    class: "pa-2 px-4 ms-4",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isAdd.value = true), ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Nova Filial ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (!data.value.subsidiary_id)
              ? (_openBlock(), _createElementBlock("small", _hoisted_6, "* É obrigatório escolher uma filial "))
              : _createCommentVNode("", true),
            _createVNode(_unref(AtomInput), {
              "append-icon": "",
              prependIcon: "",
              noBgPrependIcon: "",
              noBorderPrependIcon: "",
              placeholder: "Pesquisar",
              modelValue: search.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search).value = $event)),
              width: "100%",
              classes: "w-100 my-3"
            }, _createSlots({
              prependIcon: _withCtx(() => [
                _createVNode(_unref(SearchIcon))
              ]),
              _: 2
            }, [
              (search.value)
                ? {
                    name: "appendIcon",
                    fn: _withCtx(() => [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => { search.value = ''}, ["prevent","stop"]))
                      }, "X")
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue"]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchCompanies), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["d-flex align-center justify-space-between py-6 px-4 border rounded item-user mb-5", { active: data.value.subsidiary_id == item.id }]),
                  onClick: ($event: any) => (setResponsable(item))
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.fantasy_name), 1),
                  _createVNode(_unref(AtomCheckBox), {
                    onClick: ($event: any) => (setResponsable(item)),
                    checked: data.value.subsidiary_id == item.id
                  }, null, 8, ["onClick", "checked"])
                ], 10, _hoisted_8))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "btnConfitmDisabled"]),
    _createVNode(_unref(MoleculeCompanyModal), {
      "show-modal": isAdd.value,
      onOnHandleClose: handleAddCompany,
      users: __props.users
    }, null, 8, ["show-modal", "users"])
  ], 64))
}
}

})